import ErrorIcon from '@mui/icons-material/Error';
import { Grid, Theme, Typography, useMediaQuery, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getPartnerName, getServicingOpCo } from '../../../app/store/combinedSelectors';
import {
  DEFAULT_BANNER_ERROR_MESSAGE,
  DEFAULT_BANNER_ERROR_MESSAGE_WITHOUT_CALL_US,
  reloadPageBtn,
} from '../../../Constants/Constants';
import { PostMessageCodes } from '../../../Constants/PostMessageCodes';
import { mapContactNumber } from '../../../utils/ContactNumber-Util';
interface ErrorBannerInfo {
  claimNumber?: string;
  // Overrides the default copy. Used for cases with their own approved wording.
  message?: string;
  // Show the reload button. Defaults to true, set false when a reload will not help.
  showReloadButton?: boolean;
}

export default function ErrorBanner(props: ErrorBannerInfo) {
  const theme: Theme = useTheme();
  const { state } = useLocation();
  const opco = useSelector(getServicingOpCo);
  const partnerName = useSelector(getPartnerName);
  const contactNumber = mapContactNumber(opco, partnerName);
  const { claimNumber } = (state as ErrorBannerInfo) || {};
  const showReloadButton = props.showReloadButton ?? true;

  /*
  An explicit message wins. Otherwise use the default copy, which differs only on whether we
  have a contact number to point the customer at.
  */
  const bannerMessage =
    props.message ?? (contactNumber ? DEFAULT_BANNER_ERROR_MESSAGE : DEFAULT_BANNER_ERROR_MESSAGE_WITHOUT_CALL_US);

  function handleError() {
    window.parent.postMessage(
      {
        messageName: PostMessageCodes.DIGITAL_CLAIM_V2_RELOAD_BUTTON_CLICK,
        claimNumber: claimNumber ? claimNumber : '',
      },
      '*'
    );
  }

  const matches = useMediaQuery('(min-width:600px)');
  return (
    <Box
      sx={{
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: theme.custom.styles.errorWarningIconColor,
        width: '100%',
        display: 'flex',
        marginBottom: '2rem',
      }}
    >
      <Grid container justifyContent="space-between">
        <Grid item xs={12} sm={2} sx={{ padding: '1rem', textAlign: 'center' }}>
          <ErrorIcon
            sx={{
              color: theme.custom.styles.errorWarningIconColor,
              height: '2.5em !important',
              width: '2.5em !important',
            }}
          ></ErrorIcon>
        </Grid>
        <Grid
          item
          xs={12}
          // Take the button's column when there is no button.
          sm={showReloadButton ? 8 : 10}
          sx={{
            textAlign: 'left',
            display: 'flex',
            padding: '1rem',
            margin: 'auto',
          }}
        >
          <Typography variant="body1" sx={{ marginRight: matches ? '3rem' : '0rem' }}>
            {bannerMessage}
          </Typography>
        </Grid>
        {showReloadButton && (
          <Grid
            item
            xs={12}
            sm={2}
            sx={{
              padding: '1rem',
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Button
              onClick={handleError}
              variant="outlined"
              sx={{
                ...theme.custom.styles.genericPrimaryButton,
                marginRight: matches ? '3rem' : '0rem',
                minWidth: 'max-content',
                backgroundColor: theme.custom.colors.secondaryColor,
                color: theme.custom.colors.primaryColor,
              }}
            >
              {reloadPageBtn}
            </Button>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
